const PurchaseCalculator = () => {
  return <>Purchase Calculator</>;
};

export default PurchaseCalculator;
